import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Result, ResultV2 } from '@shared/data-access';
import { NotificationService } from '../service/notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private notification: NotificationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if ('message' in error.error) {
          const errorResult = error.error as Result<unknown>;

          if (error.status >= 400 && error.status < 500) {
            this.notification.addWarning(errorResult.message);
          } else {
            this.notification.addError(errorResult.message);
          }
        }

        if ('Message' in error.error) {
          const errorResult = error.error as ResultV2;

          if (error.status >= 400 && error.status < 500) {
            this.notification.addWarning(errorResult.Message);
          } else {
            this.notification.addError(errorResult.Message);
          }
        }

        return throwError(() => error);
      })
    );
  }
}
